<script>
import { usePageCommanderPro } from "./mixin";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import StickyFooter from "@/components/molecules/sticky-footer";
import UnauthorizedProductsPro from "@/components/organisms/unauthorized-products-pro/mobile";
import Titre from "@/components/atoms/titre";

import bandeauLegalVapotageMobile from "@/assets/images/bandeau-legal-vapotage-mobile.jpg";
import bandeauLegalAlcoolMobile from "@/assets/images/bandeau-legal-alcool-mobile.jpg";

export default {
  components: {
    Icon,
    Badge,
    Container,
    LazyImage,
    Button,
    Card,
    StickyFooter,
    UnauthorizedProductsPro,
    Titre
  },
  setup() {
    const { magasinName, checkout, unauthProducts, removeUnauthProducts } =
      usePageCommanderPro();
    return {
      magasinName,
      checkout,
      unauthProducts,
      removeUnauthProducts,
      bandeauLegalVapotageMobile,
      bandeauLegalAlcoolMobile
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <div class="c-checkout-mobile">
      <p class="c-checkout-mobile__location u-text-center">
        <Icon
          name="location"
          size="sm"
          class="u-mr-xxs"
        />
        Magasin {{ magasinName }}
      </p>
      <Container>
        <div class="c-checkout-mobile__step">
          <h1 class="c-checkout-mobile__step-title c-checkout-mobile__step-title--current u-mb-xs u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge c-checkout-mobile__step-badge--current"
              circle
            >
              1
            </Badge> Modalités de commande
          </h1>
          <div
            v-if="checkout"
            class="c-checkout__step--container"
          >
            <template v-if="unauthProducts">
              <UnauthorizedProductsPro
                :unauthorized-products="unauthProducts"
                @validate="removeUnauthProducts()"
              />
            </template>
            <template v-else>
              <Card
                radius="md"
                elevation="sm"
                class="u-p-md"
              >
                <Titre
                  tag="h2"
                  variant="primary"
                  class="u-mb-md"
                >
                  Informations sur le retrait au Drive
                </Titre>
                <p
                  class="u-font-16"
                  v-html="checkout.attributes.modalitiesHtml"
                />
              </Card>
              <StickyFooter class="u-text-center">
                <Button
                  variant="secondary"
                  radius="full"
                  size="md"
                  to="/commander-pro/infos-facturation"
                >
                  Je valide
                </Button>
              </StickyFooter>
            </template>
          </div>
        </div>
      </Container>
    </div>
    <div class="c-checkout-mobile__bottom">
      <Container>
        <div class="c-checkout-mobile__step u-mt-xs">
          <h2 class="c-checkout-mobile__step-title u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge"
              circle
            >
              2
            </Badge> Informations de facturation
          </h2>
        </div>

        <div class="c-checkout-mobile__step u-mt-xs">
          <h2 class="c-checkout-mobile__step-title u-font-24">
            <Badge
              class="c-checkout-mobile__step-badge"
              circle
            >
              3
            </Badge> Confirmation
          </h2>
        </div>

        <Container class="u-text-center">
          <LazyImage
            :src="bandeauLegalAlcoolMobile"
            alt="Interdiction de vente de boissons alcooliques aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
            class="u-mb-md"
            width="344"
            height="234"
          />
          <LazyImage
            :src="bandeauLegalVapotageMobile"
            alt="Interdiction de vente de produits du vapotage aux mineurs de moins de 18 ans.
                La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne."
            class="u-pb-md"
            width="344"
            height="234"
          />
        </Container>
      </Container>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/checkout-mobile.scss";
</style>
